

export default class MapCommand {

    constructor(options) {
        this._options = options || {};
    }

    getName() {
        return this._name;
    }

    execute(olMap, params) {
        // nop;
    }
}
